import { useState } from "react";
import { hexToRgba } from "../../../../helpers/helper";
import { Dropdown } from "antd";
import { DotsThree } from "@phosphor-icons/react";
import { colors } from "../../../../services/style";

export const PaginationSectors = ({ sectors, initialIndex = 0, onSelect, active, dropdownHeigth }) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);

    const mountActiveColor = (sector, activeColor, inactiveColor) => {
        return active?.id == sector?.id  ? activeColor : inactiveColor
    }

    const generateAlertStyles = (sector) => {
        const sectorsStyle = {
            backgroundColor: mountActiveColor(sector, colors.primary[100],colors["sl-gray"][150] ),
            color: mountActiveColor(sector, colors.primary[600],'white' ),
            border: `solid 1.5px ${mountActiveColor(sector, colors.primary[600],colors["sl-gray"][400] )}`,
        }

        const activeStyles = {
            backgroundColor: mountActiveColor(sector, colors.primary[100],hexToRgba(sector?.devices?.[0]?.color, 0.4) ) ,
            color: mountActiveColor(sector, colors.primary[600], 'white'),
            border: `solid 1.5px ${mountActiveColor(sector, colors.primary[600],sector?.devices?.[0]?.color)}`,
        }
        return sector?.alert_counts ? activeStyles : sectorsStyle
    }
    const getVisibleSectors = () => {
        const total = sectors.length;

        if (total <= 3) return sectors;

        if (currentIndex === 0) return sectors.slice(0, 3);
        if (currentIndex === total - 1) return sectors.slice(-3);

        return sectors.slice(currentIndex - 1, currentIndex + 2);
    };

    const visibleSectors = getVisibleSectors();
    const visibleIds = visibleSectors.map((s) => s.id);
    const hiddenSectors = sectors.filter((s) => !visibleIds.includes(s.id));

    const handleSelect = (index) => {
        setCurrentIndex(index);
        onSelect?.(sectors[index].id);
    };

    const tab = (sector) => {
        return (
            <div
                key={sector.id}
                id={`sector-${sector.id}`}
                className={`flex items-center justify-center p-1 rounded-[8px] central-modal-title-tab cursor-pointer w-[150px] relative pr-10`}
                title={sector.name}
                style={generateAlertStyles(sector)}
                onClick={() => handleSelect(sectors.findIndex((s) => s.id === sector.id))}
            >
                <span className="text-medium central-modal-title-tabs-text truncate ">{sector.name}</span>

                {sector.alert_counts ? (
                    <div
                        style={{ backgroundColor: mountActiveColor(sector, colors.primary[600], sector.devices?.[0]?.color), color: 'white' }}
                        className="rounded-full central-modal-general-footer-quantity ml-1 absolute right-1"
                    >
                        <span className="font-semibold">{sector.alert_counts}</span>
                    </div>
                ) : null}
            </div>
        )
    }

    return (
        <div className="flex items-center gap-2 select-none mr-2 ">
            {visibleSectors.map((sector) => tab(sector))}

            {hiddenSectors.length ? <Dropdown
                menu={{
                    items: hiddenSectors.map((sector) => ({
                        label: tab(sector),
                        key: sector.id
                    })),
                    className: 'black-scroll',
                    style: {
                        backgroundColor: colors["sl-gray"][1000],
                        maxHeight: dropdownHeigth,
                        overflow: 'auto'
                    }
                }}
                style={{ width: 150, }}
                trigger={['click']}
            >
                <div
                    className={`flex items-center justify-center p-1 rounded-[8px] central-modal-title-tab cursor-pointer`}
                    style={generateAlertStyles()}
                >
                    <DotsThree size={32} />


                </div>
            </Dropdown> : null}
        </div>
    );
};

